// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__1wVH0","itemTitle":"ClientEmergencyInfo_itemTitle__o8tIg","itemText":"ClientEmergencyInfo_itemText__1t_TH"};